import API from '@/api';

const types = {
  SET_COMPANIES: 'SET_COMPANIES',
  SET_LOADING_COMPANIES: 'SET_LOADING_COMPANIES',
};

const state = {
  companies: [],
  loadingCompanies: false,
};

const getters = {};

const mutations = {
  [types.SET_COMPANIES](state, companies) {
    state.companies = companies;
  },
  [types.SET_LOADING_COMPANIES](state, payload) {
    state.loadingCompanies = payload;
  },
};

const actions = {
  async getCompanies({ commit }) {
    commit(types.SET_LOADING_COMPANIES, true);
    const response = await API.company.getCompanies();

    const companies = response.data.filter(c => !c.hidden);

    commit(types.SET_COMPANIES, companies);
    commit(types.SET_LOADING_COMPANIES, false);
    return companies;
  },
  async getCurrentCompanyYearOptions({ commit }, { companyId }) {
    const response = await API.company.getYearOptions(companyId);
    if (response.data.error) {
      return false;
    }
    if (!response.data.includes(2019)) {
      response.data.push(2019);
    }
    return response.data;
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true,
};
